import { Anchor, List, Popover, Text } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { useState } from "react";
import { generatePath, Link, useMatch, useResolvedPath } from "react-router";
import { ROUTES } from "../../../../routes";
import urls from "../../../../urls";
import { AnchorLink } from "../../../AnchorLink/AnchorLink";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

interface SiteNameColumnProps {
  simple: boolean;
}

function getSiteNameColumn({
  simple
}: SiteNameColumnProps): MRT_ColumnDef<SiteOverviewSite | SiteStatusSite> {
  return {
    header: "Liegenschaft",
    accessorKey: "name",
    Cell: ({ cell, row }) => (
      <LinkedLabelCell
        label={cell.getValue<string>()}
        projectId={row.original.projectId}
        simple={simple}
        siteId={row.original.id}
      />
    ),
    size: 250,
    filterFn: "includesString"
  };
}

interface LinkedLabelCellProps {
  label: string;
  siteId: number;
  projectId: string;
  simple?: boolean;
}

function LinkedLabelCell({
  label,
  siteId,
  projectId,
  simple
}: LinkedLabelCellProps) {
  const [popoverOpened, setPopoverOpened] = useState(false);

  const resolved = useResolvedPath(":year");
  const match = useMatch({ path: resolved.pathname, end: true });
  const year = match && match.params.year ? match.params.year : undefined;
  const url = year
    ? urls.siteStatusPageByYear(siteId, parseInt(year, 10))
    : urls.siteStatusPage(siteId);

  const managerVariantStructurePath = generatePath(ROUTES.site.entry, {
    projectId: projectId,
    siteId: siteId.toString()
  });

  if (simple) {
    return (
      <Anchor component={Link} to={managerVariantStructurePath}>
        {label}
      </Anchor>
    );
  }

  return (
    <Popover opened={popoverOpened} onChange={setPopoverOpened}>
      <Popover.Target>
        <Text
          className="linked-label-cell-popover-target"
          span
          onClick={() => setPopoverOpened(!popoverOpened)}
        >
          {label}
        </Text>
      </Popover.Target>
      <Popover.Dropdown>
        <List
          center
          icon={<IconExternalLink size="16" />}
          spacing="xs"
          onClick={() => setPopoverOpened(false)}
        >
          <List.Item>
            <AnchorLink href={url}>Detailansicht öffnen</AnchorLink>
          </List.Item>
          <List.Item>
            <AnchorLink href={managerVariantStructurePath}>
              In opti.node öffnen
            </AnchorLink>
          </List.Item>
        </List>
      </Popover.Dropdown>
    </Popover>
  );
}

export { getSiteNameColumn };
